module.exports = __webpack_public_path__ + "img/arrow-down-right.bd88ac7a.svg";